import { FC, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useConnection } from '../../connection/Application';
import { useHistory } from 'react-router-dom';
import { PageLoading } from '@ant-design/pro-layout';

const LogOutScreen: FC = () => {
  const { instance } = useMsal();
  const connection = useConnection();
  const history = useHistory();
  useEffect(() => {
    const logOut = async () => {
      const logoutRequest = {
        account: instance.getAccountByHomeId(instance.getActiveAccount()?.homeAccountId ?? ''),
        postLogoutRedirectUri: '/',
      };
      // Revoke server-side (bumps tokenVersion) and clear the HttpOnly cookie (VAPT-006).
      await connection.logout();
      await instance.logoutRedirect(logoutRequest);
      // await instance.logout();
      // cleanCookies();
      history.replace('/');
    };
    logOut();
  }, [connection, history, instance]);
  // eslint-disable-next-line react/react-in-jsx-scope
  return <PageLoading />;
};

export default LogOutScreen;
